export function mobileMenu(menuToggleSelector, fullscreenMenuSelector) {
  document.addEventListener("DOMContentLoaded", function () {
    const menuToggle = document.querySelectorAll(menuToggleSelector);
    const fullscreenMenu = document.querySelector(fullscreenMenuSelector);

    if (!menuToggle.length || !fullscreenMenu) {
      return;
    }

    function setOpen(isOpen) {
      fullscreenMenu.classList.toggle("open", isOpen);
      fullscreenMenu.setAttribute("aria-hidden", isOpen ? "false" : "true");
      document.body.classList.toggle("overflow-hidden", isOpen);

      menuToggle.forEach(function (toggle) {
        toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
        toggle.classList.toggle("is-open", isOpen);
      });
    }

    function toggleMenu() {
      setOpen(!fullscreenMenu.classList.contains("open"));
    }

    menuToggle.forEach(function (toggle) {
      toggle.addEventListener("click", function () {
        toggleMenu();
      });
    });

    // Close after in-panel navigations (anchor links / page links)
    fullscreenMenu.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", function () {
        setOpen(false);
      });
    });

    window.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        setOpen(false);
      }
    });

    window.matchMedia("(min-width: 1024px)").addEventListener("change", function (event) {
      if (event.matches) {
        setOpen(false);
      }
    });
  });
}
